import React from "react";
import { render } from "react-dom";
import App from "./App";
import { init } from "./services/remote";
init();
var mountNode = document.getElementById("app");
render(<App />, mountNode);
module.hot.accept();
